import { useLayout } from 'stores/LayoutStore'
import { observer } from 'mobx-react-lite'
import { PropsWithChildren } from 'react'
import Styles from './WriterToolbarContainer.module.scss'

export const WriterToolbarContainer = observer(({ children }: PropsWithChildren) => {
  const layout = useLayout()

  return (
    <div className={Styles.container} ref={(node) => layout.setWriterToolbar(node)}>
      {children}
    </div>
  )
})
